import React from 'react';
import { AwardIcon } from 'lucide-react';
export function CertificateSection() {
  return <section className="w-full bg-[#0a0a0a] py-16 md:py-20 lg:py-24 px-4" data-id="element-29">
      <div className="max-w-5xl mx-auto" data-id="element-30">
        <div className="flex items-center justify-center gap-4 mb-8" data-id="element-31">
          <AwardIcon className="w-16 h-16 text-[#c41e3a]" aria-hidden="true" data-id="element-32" />
          <h2 className="text-5xl md:text-6xl font-black text-white text-center" data-id="element-33">
            Certificado de <span className="text-[#c41e3a]" data-id="element-34">Finalización</span>
          </h2>
        </div>
        <div className="w-32 h-1 bg-[#c41e3a] mx-auto mb-12" data-id="element-35"></div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-36">
          {/* Imagen del certificado */}
          <div className="flex justify-center" data-id="element-37">
            <img src="https://cdn.magicpatterns.com/uploads/4HagsNE3J1tEH2k7KUcpQJ/ChatGPT_Image_24_feb_2026,_02_08_32_a.m..png" alt="Certificado de Finalización Método Barber Pro" className="w-full max-w-md rounded-lg shadow-2xl border-4 border-gray-700" data-id="element-38" />
          </div>

          {/* Descripción */}
          <div className="text-center md:text-left" data-id="element-39">
            <h3 className="text-3xl md:text-4xl font-black text-white mb-6 leading-tight" data-id="element-40">
              Acreditá tu formación profesional
            </h3>
            <p className="text-xl md:text-2xl text-gray-300 leading-relaxed mb-6" data-id="element-41">
              Al completar la formación, recibís un{' '}
              <span className="text-white font-bold" data-id="element-42">
                certificado digital oficial
              </span>{' '}
              que valida tu conocimiento y compromiso con la excelencia en
              barbería.
            </p>
            <p className="text-lg md:text-xl text-gray-400 leading-relaxed" data-id="element-43">
              Un respaldo profesional que podés mostrar a tus clientes y usar
              para destacarte en el mercado.
            </p>
          </div>
        </div>
      </div>
    </section>;
}